import { cn } from '@/lib/utils'

interface UserListItemProps {
  label: string
  subLabel: string
  avatarClassName?: string
  avatarSizeClassName?: string
  className?: string
}

export function UserListItem({
  label,
  subLabel,
  avatarClassName,
  avatarSizeClassName = 'size-8',
  className,
}: UserListItemProps) {
  const initial = label.trim().charAt(0).toUpperCase() || '?'

  return (
    <>
      <span
        className={cn(
          'flex shrink-0 items-center justify-center rounded-full bg-[#E2F8F5] text-xs font-semibold text-[#097C69]',
          avatarSizeClassName,
          avatarClassName,
        )}
      >
        {initial}
      </span>
      <span className={cn('flex min-w-0 flex-1 flex-col text-left', className)}>
        <span className="truncate text-sm font-medium leading-5 text-[#1E1E1E]">{label}</span>
        <span className="truncate text-xs leading-4 text-[#7E8B99]">{subLabel}</span>
      </span>
    </>
  )
}
